import { Link } from "react-router-dom";
import { IconCarrot } from "../../icons/IconCarrot/IconCarrot";
import { IconCalculator } from "../../icons/IconCalculator/IconCalculator";
import { IconIncome } from "../../icons/IconIncome/IconIncome";
import { IconPlatinum } from "../../icons/IconPlatinum/IconPlatinum";
import { IconStatement } from "../../icons/IconStatement/IconStatement";
import "./LeafNavigationTile.scss";

export type LeafNavigationIconType = "calculator" | "income" | "platinum" | "statement";

interface Props {
  title: string;
  subtitle?: string;
  iconType: LeafNavigationIconType;
  to: string;
  handleModalClick?: () => void;
  className?: string;
  "data-testid"?: string;
}

const iconMap = {
  calculator: IconCalculator,
  income: IconIncome,
  platinum: IconPlatinum,
  statement: IconStatement,
};

export const LeafNavigationTile = ({
  title,
  subtitle,
  iconType,
  to,
  handleModalClick,
  className = "",
  "data-testid": dataTestId,
}: Props) => {
  const showRightArrow = to || handleModalClick;
  const IconComponent = iconMap[iconType];

  const handleClick = () => {
    if (!to && handleModalClick) {
      handleModalClick();
    }
  };

  const content = (
    <div className={`leaf-navigation-tile ${className}`}>
      <div className="leaf-navigation-tile__icon">
        <IconComponent />
      </div>
      <div className="leaf-navigation-tile__content">
        <span className="leaf-navigation-tile__title">{title}</span>
        {subtitle && <p className="leaf-navigation-tile__subtitle">{subtitle}</p>}
      </div>
      {showRightArrow && (
        <div className="leaf-navigation-tile__arrow">
          <IconCarrot orientation="right" color={"blue"} />
        </div>
      )}
    </div>
  );

  if (to) {
    return (
      <Link to={to} className="leaf-navigation-tile__link" data-testid={dataTestId}>
        {content}
      </Link>
    );
  }

  return (
    <button className="leaf-navigation-tile__btn" onClick={handleClick} data-testid={dataTestId}>
      {content}
    </button>
  );
};
